import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import ripple from '../../styles/animations/ripple'

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 60px;
  min-height: 60px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  background: ${({ theme }) => theme.colors.header || theme.colors.primary || '#2c30af'};
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  z-index: 100;
  transition: all 0.2s ease;
  overflow: hidden;

  ${down('md')} {
    padding: 0 16px;
    height: 56px;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  gap: 16px;
`

export const NavButton = styled.button`
  ${ripple}
  cursor: pointer;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: scale(0.96);
  }
`

export const ButtonRound = styled.div`
  ${ripple}
  cursor: pointer;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
  }
`

export const UserProfileChip = styled.div`
  ${ripple}
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 12px 4px 6px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 20px;
  color: #ffffff;
  transition: all 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  ${down('sm')} {
    span {
      display: none;
    }
    padding: 4px;
    border: none;
    background: transparent;
  }
`

export const SettingsButton = styled.button`
  ${ripple}
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
`

export const TitleHeader = styled.label`
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.01em;
`

export const Line = styled.div`
  width: 1px;
  background-color: rgba(255, 255, 255, 0.25);
  height: 24px;
  margin: 0 4px;
`
